@if (isLoading()) {
  <lib-overlay-loader />
} @else {
  <div class="flex flex-col h-full" [class]="floatingPageClasses()">
    <div [class]="floating() ? 'mb-lg' : 'mb-2xl'">
      <p class="text-2xl text-neutral-900 font-semibold">
        {{ 'super_managers_list_screen_title' | transloco }}
      </p>
    </div>

    <section
      class="flex flex-col justify-between flex-1"
      [class]="floating() ? 'floating-card p-2xl' : ''"
      data-testid="super-managers-list-section">
      <div>
        <div
          class="flex justify-between items-center mb-lg"
          [class]="floating() ? '' : 'py-xl border-b border-neutral-200'">
          <div class="flex gap-lg items-center">
            <p class="text-neutral-900 font-semibold text-lg">
              {{ 'super_managers_list_screen_sub_title' | transloco }}
            </p>

            <lib-badge
              [label]="totalManagersCount()"
              badgeClass="px-sm border-none text-sm font-medium bg-primary-50 text-primary-700"></lib-badge>
          </div>

          <button
            class="bg-primary-500 text-white font-medium text-sm py-sm px-lg border-none rounded-md gap-sm flex items-center"
            type="button"
            id="add_super_managers_modal_label"
            (click)="openAssignSuperManagersDialog()">
            <lib-add-icon [iconClass]="'size-5 text-white'" />

            <span class="hidden md:block">
              {{ 'add_super_managers_modal_label' | transloco }}
            </span>
          </button>
        </div>

        <div>
          <lib-group-user-card
            [actionList]="actionList"
            [list]="admins()"
            itemType="User"
            (actionListItemClickEmitter)="actionListItemClick($event)"
            [mode]="'view'" />
        </div>
      </div>

      @if (admins().length) {
        <div class="p-sm">
          <lib-paginator
            class="mt-4xl"
            [sizeOptionsLabel]="
              'pagination_number_of_rows_per_page_label' | transloco
            "
            [nextBtnLabel]="'pagination_next_button_label' | transloco"
            [previousBtnLabel]="'pagination_previous_button_label' | transloco"
            [currentPage]="currentPage()"
            [totalPages]="totalPages()"
            [totalItems]="+totalManagersCount()"
            [pageItemCount]="admins().length"
            [showChangeSize]="true"
            [sizeOptions]="pageSizeOptions"
            (goTo)="handlePagination($event)"
            (next)="handlePagination($event)"
            (previous)="handlePagination($event)"
            [showChangeSize]="false" />
        </div>
      }
    </section>
  </div>
}

<ng-template #removeSuperManager>
  <lib-remove-super-manager
    [isRemoveAdminLoading]="isRemoveSuperManagerLoading()"
    (removeAdmin)="onRemoveSuperManager()"
    (closeModal)="closeSuperManagerModal()" />
</ng-template>

<ng-template #assignSuperManagersDialog>
  <lib-assign-group-users
    [groupUsersCards]="adminUsersCards()"
    [selectedGroupUsersCards]="selectedUsers()"
    (unselectGroupUser)="removeSelectedAdminUser($event)"
    (selectGroupUser)="onSelectAdminUser($event)"
    (filterGroupUsersCards)="getUsers($event)"
    (paginateGroupUsersCards)="getUsers('', $event)"
    (saveAssignedGroupUsers)="changeAdminRole()"
    [isLoading]="isLoadingGroupUsers()"
    [currentPage]="modalCurrentPage()"
    [totalPages]="modalTotalPages()"
    [itemType]="'User'"
    [assignItemsModalTitle]="'add_super_managers_modal_label' | transloco"
    [isSubmitLoading]="isChangeAdminRoleLoading()"
    (cancelModal)="clearSelectedUsers()" />
</ng-template>
